import { store } from '../store';
import { t } from '../i18n';

export function DiscountsView() {
  const auth = store.getAuth();
  const pct = auth?.suc_count ?? 0;
  return (
    <div class="sw-tickets-shell discounts-shell">
      <div class="sw-surface-card discounts-card text-center">
        <div class="discounts-card__value">{pct}%</div>
        <h4 class="discounts-card__title">{t('discounts.title')}</h4>
        <p class="discounts-card__description mb-0">{t('discounts.description')}</p>
      </div>
    </div>
  );
}
